

















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Surface from '@/components/atoms/Surface/Surface.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';

@Component({ components: { Surface, TableCell } })
export default class Row extends Vue {
  @Prop({ default: false }) readonly options?: boolean;
  @Prop({ default: false }) readonly disabled?: boolean;
  @Prop({ default: true }) readonly clickable?: boolean;

  @Emit('click')
  click(e: any) {
    return e;
  }
}
